import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

type Parameters = GA4GeneralProps & {
  pagePosition?: string | null
  documentId?: string | null
  componentRenderedClass?: string | null
  componentRenderedName?: string | null
}

export class GA4CustomComponentRenderedEvent extends GA4Event {
  ga4_page_position?: string | null
  ga4_document_id?: string | null
  ga4_component_rendered_class?: string | null
  ga4_component_rendered_name?: string | null

  constructor({
    pagePosition = null,
    documentId = null,
    componentRenderedClass = null,
    componentRenderedName = null,
    ...generalProps
  }: Parameters) {
    super({ event: EVENT.CUSTOM_COMPONENT_RENDERED, ...generalProps })

    this.ga4_page_position = pagePosition
    this.ga4_document_id = documentId
    this.ga4_component_rendered_class = componentRenderedClass
    this.ga4_component_rendered_name = componentRenderedName
  }
}
